import React from "react";

import BeatLoader from "react-spinners/BeatLoader";

const Loader: React.FC<{size?: number}> = ({size= 20}) => {
  return (
    <div className="loader-wrapper">
      <BeatLoader className="loader" size={size} color="#fff" />
    </div>
  );
};

export default Loader;
